import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import { getLeadersByOfferingId as getLeadersByOfferingIdQuery } from '../graphql/queries'

export const useLeadersByOfferingId = () => {
  const client = useMemo(() => generateClient(), [])
  const getLeadersByOfferingId = useCallback(
    (offeringId) => {
      return client.graphql({
        query: getLeadersByOfferingIdQuery,
        variables: { offeringId },
      })
    },
    [client],
  )

  return { getLeadersByOfferingId }
}
